import { get, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { SpendReportModel } from "@waytek/Types/SpendReport";

const baseUrl = "/api/v1";

export async function getSpendReport(year: number): Promise<ServiceResult<SpendReportModel>> {
    const result = await get<SpendReportModel>(`${baseUrl}/spendreport/${year}`);

    return {
        successful: true,
        result,
    };
}
